"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import { mapListValues } from "../../../../utils/stuff";
var _default = function _default(_ref) {
  var listValues = _ref.listValues,
      value = _ref.value,
      setValue = _ref.setValue,
      allowCustomValues = _ref.allowCustomValues,
      readonly = _ref.readonly;
  var onChange = (0, _react.useCallback)(function (e) {
    setValue(e.length > 0 ? e.map(function (item) {
      return item.value;
    }) : undefined);
  }, [setValue]);
  var selectedValues = (0, _react.useMemo)(function () {
    if (value) {
      return listValues.filter(function (item) {
        return value.indexOf(item.value) > -1;
      });
    }

    return [];
  }, [value, listValues]);
  return /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Form.Select, {
    labelKey: "title",
    id: "select-typeahead-multi",
    onChange: onChange,
    selected: selectedValues,
    disabled: readonly,
    options: listValues,
    size: "sm",
    placeholder: "Select",
    multiple: true,
    clearButton: true
  });
};

exports["default"] = _default;